/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaArrowRight } from 'react-icons/fa';
export var SendETH = createPlugin({
    protocol: 'UTILITY',
    type: 'ACTION',
    description: 'Send ETH',
    method: '',
    name: 'sendETH',
    getParams: function () { return ({
        input: {
            to: new FctAddress({ isPreview: true }),
            value: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaArrowRight }),
            methodParams: {},
        },
        output: {},
    }); },
    initParams: {},
});
